define([
    'text!./templates/basler-sticky-help.html',
    ], (templateStr) => {
        return ['StateUtils', 'httpSettings', '$window', 'LocaleService', 'BaslerCommonService', (StateUtils, httpSettings, $window, LocaleService, BaslerCommonService) => { //NOSONAR
                return {
                    restrict: 'E',
                    scope: {
                        selectedOffering: '=',
                    },
                    template: templateStr,
                    link: function ($scope) { // NOSONAR
                        // Mail:
                        const submissionValue = StateUtils.activeDataForState(true).model.value;
                        $scope.contactVisible = submissionValue && submissionValue.draftData && (['BaloiseDirectMotorfahrzeug'].includes(submissionValue.draftData.productCode));

                        $scope.quoteId = submissionValue.quoteID;
                        $scope.sessionId = submissionValue.sessionUUID;
                        $scope.showInfo = false;
                        $scope.isEnglish = BaslerCommonService.isEnglishman(LocaleService.getCurrentLocale());

                        // Download:
                        $scope.encodedDocId = encodeURIComponent($scope.selectedOffering.docID.value);
                        $scope.downloadURI = httpSettings.serviceBaseURLs.quotedocument;
                        $scope.documentNotFoundURL = `${`${$window.location.pathname.substring(0, $window.location.pathname.lastIndexOf('/'))}/QuoteDocumentError-`}${LocaleService.getCurrentLocale()}`;

                        // handle event, when selected offering is changed by user:
                        $scope.$on('selectedOfferingChanged', (event, obj) => {
                            const {docId} = obj;
                            $scope.encodedDocId = encodeURIComponent(docId);
                        });

                        $scope.toggleInfo = () => {
                            $scope.showInfo = !$scope.showInfo;
                        };
                    },
                };
            },
        ];
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/BaslerStickyHelp.js